<template>
  <div>
    <!-- <iframe
      v-if="
        $route.query.type == 'DOC_SIGN_CONSENT' ||
        ($route.query.type == 'FILTER' &&
          $route.query.statusFilter == 'DOC_DRAFF_WAITING')
      "
      :src="fileBase64"
      width="100%"
      frameborder="0"
      class="preview-iframe"
    ></iframe> -->
    <div
      v-if="
        $route.query.type == 'DOC_SIGN_TEMP' ||
        ($route.query.type == 'FILTER' &&
          $route.query.statusFilter !== 'DOC_DRAFF_WAITING')
      "
      class="preview-iframe"
    >
      <ViewPdf
        :fileId="fileId"
        :currentPage="pageNum"
        @changePageNum="changePageNum"
        @canvasDimensions="handleCanvasDimensions"
        @pdfSize="handlePdfSize"
      />
    </div>
    <!-- End Preview File -->

    <!-- Start Preview File -->
    <div
      class="body-pdf"
      v-if="
        $route.query.type == 'DOC_SIGN_CONSENT' ||
        ($route.query.type == 'FILTER' &&
          $route.query.statusFilter == 'DOC_DRAFF_WAITING')
      "
    >
      <div
        class="pdf-container"
        :style="
          drawerVisible
            ? 'right: 0%; width: 75%'
            : 'right: 0%; width: 98%'
        "
      >
        <div class="dropzone" :style="{ maxWidth: canvasDimensions.width > 0 ? canvasDimensions.width + 'px' : '833px' }">
          <div class="pdf-content" id="pdf-content">
            <div class="canvas text-center pdfViewer singlePageView nopadding">
              <ViewPdf
                @changePageNum="changePageNum"
                @canvasDimensions="handleCanvasDimensions"
                :fileId="fileId"
                :currentPage="pageNum"
                :pageSign="pageSign"
                @pdfSize="handlePdfSize"
              />
              <Draggable
                v-if="imgSignId"
                :key="`doc-sign-${signatureRenderKey}-${imgSignId || 'empty'}-${pageNum}-${dataObject.position && dataObject.position.page_index ? dataObject.position.page_index : 0}`"
                @endDragSign="endDragSign"
                @endResizeSign="endResizeSign"
                @removeSignImage="fn_deleteSignImage"
                :imageSignId="imgSignId"
                :pageNum="pageNum"
                :positionSign="dataObject.position"
                :currentPage="pageNum"
                :from="imgSignId ? 'DrafDocument' : ''"
                :isDraggabled="true"
                :isResizable="true"
              />
              <!-- Start Giáp lai visual preview overlay -->
              <div
                v-if="isGiapLai && numPages > 1 && giapLaiSliceInfo"
                class="giap-lai-preview-wrapper"
                :style="{
                  position: 'absolute',
                  top: giapLaiSliceInfo.top_px + 'px',
                  right: giapLaiSliceInfo.right_px + 'px',
                  zIndex: 25,
                  pointerEvents: 'auto',
                  cursor: 'pointer',
                  transition: 'top 0.25s ease, right 0.25s ease',
                }"
                @mouseenter="isHoverGiapLaiSlice = true"
                @mouseleave="isHoverGiapLaiSlice = false"
                :title="`Dấu giáp lai mép phải - Trang ${pageNum}/${numPages} (Lát cắt ${giapLaiSliceInfo.sliceIndex}/${giapLaiSliceInfo.totalInCluster} con dấu)`"
              >
                <!-- Ghost seal watermark: hiển thị mờ toàn bộ con dấu gốc khi hover để người dùng thấy rõ vị trí lát cắt -->
                <div
                  v-if="isHoverGiapLaiSlice"
                  :style="{
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    width: giapLaiSliceInfo.D_px + 'px',
                    height: giapLaiSliceInfo.D_px + 'px',
                    opacity: 0.35,
                    border: '1.5px dashed #dc2626',
                    borderRadius: '50%',
                    pointerEvents: 'none',
                    overflow: 'hidden',
                    zIndex: 1,
                    backgroundColor: 'rgba(254, 242, 242, 0.4)',
                    boxShadow: '0 4px 16px rgba(220, 38, 38, 0.35)',
                  }"
                >
                  <img
                    v-if="companySealUrl"
                    :src="companySealUrl"
                    :style="{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      pointerEvents: 'none',
                    }"
                    alt="Toàn bộ con dấu gốc"
                  />
                  <svg
                    v-else
                    :width="giapLaiSliceInfo.D_px"
                    :height="giapLaiSliceInfo.D_px"
                    viewBox="0 0 200 200"
                    :style="{ pointerEvents: 'none' }"
                  >
                    <circle cx="100" cy="100" r="95" fill="none" stroke="#dc2626" stroke-width="4" opacity="0.9" />
                    <circle cx="100" cy="100" r="88" fill="rgba(254, 226, 226, 0.4)" stroke="#dc2626" stroke-width="1.5" stroke-dasharray="3,2" opacity="0.9" />
                    <circle cx="100" cy="100" r="60" fill="none" stroke="#dc2626" stroke-width="1.5" opacity="0.8" />
                    <circle cx="100" cy="100" r="76" fill="none" stroke="#dc2626" stroke-width="1" stroke-dasharray="6,4" opacity="0.7" />
                    <polygon points="100,68 108,86 128,88 113,101 117,121 100,111 83,121 87,101 72,88 92,86" fill="#dc2626" opacity="0.9" />
                    <text x="100" y="46" font-size="13" font-weight="bold" fill="#dc2626" text-anchor="middle" letter-spacing="2" style="font-family: 'LexendDeca Regular', sans-serif;">DẤU GIÁP LAI</text>
                    <text x="100" y="160" font-size="11" font-weight="bold" fill="#dc2626" text-anchor="middle" letter-spacing="1.5" style="font-family: 'LexendDeca Regular', sans-serif;">VĂN BẢN ĐIỆN TỬ</text>
                  </svg>
                </div>

                <!-- Lát cắt thực tế của trang hiện tại -->
                <div
                  class="giap-lai-preview-slice"
                  :style="{
                    position: 'relative',
                    width: giapLaiSliceInfo.sliceWidth_px + 'px',
                    height: giapLaiSliceInfo.D_px + 'px',
                    overflow: 'hidden',
                    border: '1.5px dashed #dc2626',
                    borderRadius: '2px',
                    backgroundColor: 'transparent',
                    boxShadow: '0 2px 8px rgba(220, 38, 38, 0.25)',
                    zIndex: 2,
                  }"
                >
                  <!-- Ảnh con dấu thật của công ty nếu có -->
                  <img
                    v-if="companySealUrl"
                    :src="companySealUrl"
                    :style="{
                      position: 'absolute',
                      top: '0',
                      left: `-${giapLaiSliceInfo.offsetX_px}px`,
                      width: `${giapLaiSliceInfo.D_px}px`,
                      height: `${giapLaiSliceInfo.D_px}px`,
                      maxWidth: 'none',
                      maxHeight: 'none',
                      opacity: 0.95,
                      pointerEvents: 'none',
                    }"
                    alt="Dấu giáp lai"
                  />

                  <!-- SVG con dấu tròn đỏ chuẩn nếu chưa có ảnh dấu -->
                  <svg
                    v-else
                    :width="giapLaiSliceInfo.D_px"
                    :height="giapLaiSliceInfo.D_px"
                    viewBox="0 0 200 200"
                    :style="{
                      position: 'absolute',
                      top: '0',
                      left: `-${giapLaiSliceInfo.offsetX_px}px`,
                      pointerEvents: 'none',
                    }"
                  >
                    <circle cx="100" cy="100" r="95" fill="none" stroke="#dc2626" stroke-width="4" opacity="0.9" />
                    <circle cx="100" cy="100" r="88" fill="rgba(254, 226, 226, 0.4)" stroke="#dc2626" stroke-width="1.5" stroke-dasharray="3,2" opacity="0.9" />
                    <circle cx="100" cy="100" r="60" fill="none" stroke="#dc2626" stroke-width="1.5" opacity="0.8" />
                    <circle cx="100" cy="100" r="76" fill="none" stroke="#dc2626" stroke-width="1" stroke-dasharray="6,4" opacity="0.7" />
                    <polygon points="100,68 108,86 128,88 113,101 117,121 100,111 83,121 87,101 72,88 92,86" fill="#dc2626" opacity="0.9" />
                    <text x="100" y="46" font-size="13" font-weight="bold" fill="#dc2626" text-anchor="middle" letter-spacing="2" style="font-family: 'LexendDeca Regular', sans-serif;">DẤU GIÁP LAI</text>
                    <text x="100" y="160" font-size="11" font-weight="bold" fill="#dc2626" text-anchor="middle" letter-spacing="1.5" style="font-family: 'LexendDeca Regular', sans-serif;">VĂN BẢN ĐIỆN TỬ</text>
                    <line x1="15" y1="100" x2="185" y2="100" stroke="#dc2626" stroke-width="1" stroke-dasharray="4,4" opacity="0.4" />
                  </svg>
                </div>
              </div>
              <!-- End Giáp lai visual preview overlay -->
            </div>
          </div>
          <div class="paging ml-26 text-center">
            <p>
              Trang
              <el-input-number
                class="current-page ml-1 mr-1"
                :controls="false"
                v-model="pageNum"
                @change="changePage(pageNum)"
                :min="1"
                :max="numPages"
              ></el-input-number>
              / {{ numPages }}
            </p>
          </div>
        </div>
      </div>
      <div>
        <!-- Start Drawer -->
        <div class="drawer-container">
          <!-- Start full drawer -->
          <div v-if="drawerVisible" class="drawer">
            <div class="drawer__header d-flex align-items-center">
              <i
                class="icon el-icon-d-arrow-right mt-1 mr-2"
                @click="fn_toggleDrawer"
              ></i>
              <p class="drawer__header-title">Thanh công cụ</p>
            </div>

            <!-- Start main Sign images -->
            <div class="drawer__box">
              <p class="drawer__box-title">Chữ ký cá nhân</p>
              <div class="drawer__box-content">
                <p
                  v-if="
                    fileUploadOption.FileChuKy.listImageSigns.length == 0 &&
                    isClickTagChooseSignature
                  "
                  class="empty__tab-text text-center"
                >
                  Không có dữ liệu.
                </p>
                <p
                  v-if="
                    fileUploadOption.FileChuKy.listImageSigns.length == 0 &&
                    !isClickTagChooseSignature
                  "
                  class="empty__tab-text text-center"
                >
                  Vui lòng chọn người ký bên dưới để cấu hình chữ ký.
                </p>
                <!-- Start list Sign image -->
                <div v-else class="list-sign-image" id="selectorContainer">
                  <el-radio-group
                    v-model="imgSignId"
                    class="radio-group"
                    @change="changeSignImage(imgSignId)"
                  >
                    <el-radio
                      v-for="(item, index) in fileUploadOption.FileChuKy
                        .listImageSigns"
                      :key="index"
                      :label="item.sign_image_id"
                    >
                      <div class="border-image">
                        <el-image :src="item.url" fit="cover"></el-image>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
                <!-- End list Sign images -->
              </div>
            </div>
            <!-- End main Sign images -->

            <!-- Start Giap Lai Option -->
            <div class="drawer__box" v-if="numPages > 1 && isAllowedGiapLai">
              <p class="drawer__box-title">Dấu giáp lai</p>
              <div class="drawer__box-content px-3 py-2">
                <el-checkbox v-model="isGiapLai">Đóng dấu giáp lai mép phải</el-checkbox>
              </div>
            </div>
            <!-- End Giap Lai Option -->
          </div>
          <!-- End full drawer -->
          <!-- Start collapse drawer -->
          <div
            class="drawer-collapse"
            v-if="!drawerVisible"
          >
            <div>
              <div
                class="drawer__header d-flex align-items-center"
                style="cursor: pointer"
                @click="fn_toggleDrawer"
              >
                <i class="icon el-icon-d-arrow-left mb-1"></i>
                <p class="drawer__header-title">Thanh công cụ</p>
              </div>
            </div>
          </div>
          <!-- End collapse drawer -->
        </div>
        <!-- End Drawer -->
      </div>
    </div>

    <!-- Start Manipulate button -->
    <div class="d-flex justify-content-between align-items-center mt-3 pb-3">
      <div v-if="numPages > 1 && isAllowedGiapLai" class="d-flex align-items-center">
        <span class="bold mr-2 text-nowrap" style="font-size: 14px; color: #262626;">Giáp lai:</span>
        <div
          class="giap-lai-btn d-flex align-items-center"
          :class="{ 'is-checked': isGiapLai }"
          @click="toggleGiapLai"
          role="button"
          tabindex="0"
          :title="isGiapLai ? 'Bấm để tắt dấu giáp lai' : 'Bấm để bật đóng dấu giáp lai mép phải'"
        >
          <span class="giap-lai-label ml-3 mr-2">Đóng dấu giáp lai mép phải</span>
          <i
            class="icon mr-2 el-icon-check"
            :style="{
              visibility: isGiapLai ? 'visible' : 'hidden',
              fontSize: '14px',
              fontWeight: '700',
              color: '#000'
            }"
          ></i>
        </div>
      </div>
      <div v-else></div>
      <div>
        <el-button class="btn__doc btn__doc-back" @click="fn_goBack"
          >Quay lại</el-button
        >
        <el-button class="btn__doc btn__doc-download" @click="fn_downloadFile">Tải file</el-button>
        <!-- :disabled="!historySign.imageSignId" -->
        <el-button class="btn__doc btn__doc-transfer" @click="fn_submitForm()"
          >{{
            $route.query.type == "DOC_SIGN_CONSENT" ||
            ($route.query.type == "FILTER" &&
              $route.query.statusFilter !== "DOC_DRAFF_WAITING")
              ? "Ký duyệt"
              : "Ký nháy"
          }}
        </el-button>
      </div>
    </div>
    <!-- End Manipulate button -->
    <Loading v-if="loading" />

  </div>
</template>
<script>
import ExtensionService from "../../../service/ExtensionService";
import MethodService from "../../../service/MethodService";
import SignatureDigitalService from "../../../service/SignatureDigitalService";

import DocumentApi from "../../../moduleApi/DocumentApi";
import PopupDialog from "../../../component/Popup/PopupDialog";

import EmployeeApi from "../../../moduleApi/EmployeeApi";
import FileApi from "../../../moduleApi/FileApi";
import { dataDocMixins } from "./DocumentMixins/dataDocMixins";
import { fnDocMixins } from "./DocumentMixins/fnDocMixins";
import VueDocPreview from "vue-doc-preview";
import ViewPdf from "@/component/Draggable/ViewPdf";
import EmployeeSignatureApi from "@/moduleApi/EmployeeSignatureApi";
import CompanySignApi from "@/moduleApi/CompanySignApi";
import Draggable from "@/component/Draggable/Draggable";
import Loading from "@/component/Loading";
export default {
  mixins: [dataDocMixins, fnDocMixins],
  components: {
    VueDocPreview,
    ViewPdf,
    Draggable,
    Loading,
    PopupDialog,
  },
  data() {
    return {
      ExtensionService,
      loading: false,
      isDigitalSignature: false,
      isGiapLai: false,
      companySealImageId: null,
      isHoverGiapLaiSlice: false,
      fileBase64: undefined,
      url: "",
      listMainSigner: [],
      isShowBtnDocSignTemp: false,
      isShowTutorialSignDigital: false,
      fileId: "",
      drawerVisible: false,
      imgSignId: undefined,
      listEmployeeSignatures: [],
      fileUploadOption: {
        FileChuKy: {
          accept: ".png",
          dialogImageUrl: "",
          listImageSigns: [],
        },
      },
      pageNum: 1,
      pageSign: 0,
      numPages: 0,
      signatureRenderKey: 0,
      pdfHeight: 0,
      historySign: {
        imageSignId: undefined,
        pageSigned: 0,
        positionX: 0,
        positionY: 0,
        width: 150,
        height: 150,
        page_index: 1,
      },
      haveHistory: false,
      dataObject: {},
      currentEmployeeInfo: MethodService.getEmployeeInfo(),
      updateListTagUI: false,
      isClickTagChooseSignature: false,
      isDuplicatedSigner: false,
      canvasDimensions: {
        width: 0,
        height: 0
      },
      pdfSize: { width: 0, height: 0 },
    };
  },

  computed: {
    isAllowedGiapLai() {
      if (this.numPages <= 1) return false;
      const roles = (this.$store.state.listEmployeeRoles || []).map((r) =>
        String(r).trim().toUpperCase()
      );
      const currentRole = (this.$store.state.currentEmployeeRoleCode || "")
        .trim()
        .toUpperCase();
      const allowedRoles = ["VT", "CEO", "GD", "GĐ"];
      if (
        allowedRoles.includes(currentRole) ||
        roles.some((r) => allowedRoles.includes(r))
      ) {
        return true;
      }
      const emp = this.currentEmployeeInfo || MethodService.getEmployeeInfo();
      const posCode = (emp && emp.position && emp.position.code
        ? String(emp.position.code)
        : ""
      )
        .trim()
        .toUpperCase();
      const posName = (emp && emp.position && emp.position.name
        ? String(emp.position.name)
        : ""
      )
        .trim()
        .toLowerCase();
      if (allowedRoles.includes(posCode)) return true;
      if (
        posName.includes("văn thư") ||
        posName.includes("giám đốc") ||
        posName.includes("tổng giám đốc")
      ) {
        return true;
      }
      return false;
    },

    companySealUrl() {
      if (this.companySealImageId) {
        return ExtensionService.urlImg + this.companySealImageId;
      }
      return null;
    },


    giapLaiSliceInfo() {
      if (!this.isGiapLai || this.numPages <= 1 || !this.isAllowedGiapLai) return null;
      const totalPages = this.numPages;
      const currentPage = this.pageNum;
      const clusterIdx = Math.floor((currentPage - 1) / 5);
      const totalClusters = Math.ceil(totalPages / 5);
      const startPage = clusterIdx * 5 + 1;
      const endPage = Math.min(totalPages, (clusterIdx + 1) * 5);
      const totalInCluster = endPage - startPage + 1;
      const sliceIdx = (currentPage - 1) % 5;

      let yFrac = 0.50;
      if (totalClusters >= 2) {
        const yFracMin = 0.20;
        const yFracMax = 0.80;
        const gapFrac = (yFracMax - yFracMin) / (totalClusters - 1);
        yFrac = yFracMin + clusterIdx * gapFrac;
      }

      const canvasW = (this.canvasDimensions && this.canvasDimensions.width) || 800;
      const canvasH = (this.canvasDimensions && this.canvasDimensions.height) || 1130;
      const pdfW = (this.pdfSize && this.pdfSize.width) || (canvasW / 1.4);
      const pdfH = (this.pdfSize && this.pdfSize.height) || (canvasH / 1.4);

      const scaleY = canvasH > 0 && pdfH > 0 ? canvasH / pdfH : 1.4 * (96 / 72);
      const scaleX = canvasW > 0 && pdfW > 0 ? canvasW / pdfW : scaleY;

      let D_pt = 110.0;
      if (totalClusters >= 2) {
        const gapFrac = (0.80 - 0.20) / (totalClusters - 1);
        const clusterGapPt = gapFrac * pdfH;
        if (clusterGapPt < D_pt) {
          D_pt = clusterGapPt;
        }
      }

      const D_px = Math.round(D_pt * scaleY);
      const sliceWidth_px = totalInCluster === 1 ? D_px : Math.round(D_px / totalInCluster);
      const yCenter_px = Math.round(yFrac * canvasH);
      const top_px = Math.round(yCenter_px - D_px / 2);
      const right_px = Math.round(12.0 * scaleX);
      const offsetX_px = Math.round(sliceIdx * (D_px / totalInCluster));

      return {
        clusterIndex: clusterIdx + 1,
        totalClusters,
        sliceIndex: sliceIdx + 1,
        totalInCluster,
        startPage,
        endPage,
        D_px,
        sliceWidth_px,
        top_px,
        right_px,
        offsetX_px,
      };
    },
  },

  watch: {
    dataObject(newVal, oldVal) {
      setTimeout(() => {
        if (this.dataObject.sign_image_id) {
          const previewPosition = this.fn_getDisplaySignerPosition(
            this.dataObject.position
          );
          const previewSize = this.fn_getDisplaySignerSize(
            this.dataObject.position
          );
          this.imgSignId = this.dataObject.sign_image_id;
          this.historySign = {
            imageSignId: this.dataObject.sign_image_id,
            pageSigned: this.dataObject.position.page_index,
            positionX: previewPosition.x,
            positionY: previewPosition.y,
            width: previewSize.width,
            height: previewSize.height,
          };
          this.dataObject.position = {
            ...this.dataObject.position,
            x: previewPosition.x,
            y: previewPosition.y,
            width: previewSize.width,
            height: previewSize.height,
          };
          this.checkHaveHistorySign();
          this.refreshSignatureOverlay();
        }
      }, 1000);
    },
  },

  methods: {
    fn_getCanvasOffsetInPreview() {
      const root = this.$el;
      const canvas = root ? root.querySelector(".dropzone canvas") : null;
      const container = root ? root.querySelector(".dropzone .canvas") : null;
      if (!canvas || !container) {
        return { x: 0, y: 0 };
      }
      const canvasRect = canvas.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      return {
        x: Math.round(canvasRect.left - containerRect.left),
        y: Math.round(canvasRect.top - containerRect.top),
      };
    },

    fn_getPageRelativePreviewPosition(position = {}) {
      if (!this.pdfSize || !this.canvasDimensions.width) {
        return {
          x: Math.round(position.x != null ? position.x : 0),
          y: Math.round(position.y != null ? position.y : 0),
        };
      }
      const canvasW = this.canvasDimensions.width;
      const canvasH = this.canvasDimensions.height;
      if (this.fn_hasCanonicalBackendPosition(position)) {
        const DPI_RATIO = 96 / 72;
        const targetWidth = this.pdfSize.width * DPI_RATIO;
        const targetHeight = this.pdfSize.height * DPI_RATIO;
        const x = position.x != null ? position.x : 0;
        const y = position.y != null ? position.y : 0;
        return {
          x: Math.round((x * canvasW) / targetWidth),
          y: Math.round((y * canvasH) / targetHeight),
        };
      }

      if (this.fn_hasMeaningfulDelta(position)) {
        return {
          x: Math.round(position.delta_x),
          y: Math.round(position.delta_y),
        };
      }

      return {
        x: Math.round(position.x != null ? position.x : 0),
        y: Math.round(position.y != null ? position.y : 0),
      };
    },

    fn_hasMeaningfulDelta(position = {}) {
      const dx = position.delta_x;
      const dy = position.delta_y;
      return (
        dx != null &&
        dy != null &&
        (Math.abs(dx) > 2 || Math.abs(dy) > 2)
      );
    },

    fn_hasCanonicalBackendPosition(position = {}) {
      const x = Number(position.x);
      const y = Number(position.y);
      if (!(Number.isFinite(x) && Number.isFinite(y) && (x > 0 || y > 0))) {
        return false;
      }

      if (this.fn_hasMeaningfulDelta(position)) {
        return this.fn_isBackendScaledPosition(position);
      }

      return true;
    },

    fn_getDisplaySignerPosition(position = {}) {
      if (!this.pdfSize || !this.canvasDimensions.width) {
        return { x: position.x || 0, y: position.y || 0 };
      }

      const pagePosition = this.fn_getPageRelativePreviewPosition(position);
      const offset = this.fn_getCanvasOffsetInPreview();
      return {
        x: pagePosition.x + offset.x,
        y: pagePosition.y + offset.y,
      };
    },

    fn_isBackendScaledPosition(position = {}) {
      if (!this.fn_hasMeaningfulDelta(position)) return false;

      const dx = position.delta_x != null ? position.delta_x : 0;
      const dy = position.delta_y != null ? position.delta_y : 0;
      const x = position.x != null ? position.x : 0;
      const y = position.y != null ? position.y : 0;

      return Math.abs(x - dx) > 2 || Math.abs(y - dy) > 2;
    },

    fn_getDisplaySignerSize(position = {}) {
      if (!this.pdfSize || !this.canvasDimensions.width) {
        return { width: position.width || 220, height: position.height || 180 };
      }

      const DPI_RATIO = 96 / 72;
      const targetWidth = this.pdfSize.width * DPI_RATIO;
      const targetHeight = this.pdfSize.height * DPI_RATIO;
      const BE_DELTA = 0.95;
      const canvasW = this.canvasDimensions.width;
      const canvasH = this.canvasDimensions.height;

      const width = position.width || 220;
      const height = position.height || 180;

      if (position.__displayNormalized) {
        return {
          width: Math.max(80, Math.min(width, 320)),
          height: Math.max(80, Math.min(height, 320)),
        };
      }

      if (!this.fn_hasCanonicalBackendPosition(position)) {
        return {
          width: Math.max(80, Math.min(width, 400)),
          height: Math.max(80, Math.min(height, 400)),
        };
      }

      return {
        width: Math.max(
          80,
          Math.min(
            Math.round((width * BE_DELTA * canvasW) / targetWidth),
            500
          )
        ),
        height: Math.max(
          80,
          Math.min(
            Math.round((height * BE_DELTA * canvasH) / targetHeight),
            500
          )
        ),
      };
    },

    applySignerPreviewPosition(position = {}) {
      const previewPosition = this.fn_getDisplaySignerPosition(position);
      const previewSize = this.fn_getDisplaySignerSize(position);
      const previewX = previewPosition.x;
      const previewY = previewPosition.y;

      this.dataObject.position = {
        ...position,
        x: previewX != null ? previewX : 0,
        y: previewY != null ? previewY : 0,
        width: previewSize.width,
        height: previewSize.height,
        __displayNormalized: true,
      };

      this.historySign.positionX = previewX != null ? previewX : 0;
      this.historySign.positionY = previewY != null ? previewY : 0;
      this.historySign.width = previewSize.width;
      this.historySign.height = previewSize.height;
      this.historySign.pageSigned = position.page_index ? position.page_index : null;
    },

    handlePdfSize(size) {
      this.pdfSize = size;
      this.pdfHeight = size.height;
    },
    fn_downloadFile() {
      if (this.fileId) {
        window.open(ExtensionService.urlDowloadFile + this.fileId);
      } else {
        this.$notify.warning({
          message: "Không tìm thấy file để tải.",
          duration: 3000,
          customClass: "doc-warning",
        });
      }
    },
    async fn_getDataById(id) {
      const apiRes = await DocumentApi.findById(id);
      // Comment Not use to preview signature
      // if (this.$route.query.type == "DOC_SIGN_CONSENT") {
      //   this.loading = true;
      //   pdfPreview = await DocumentApi.ViewSignOnPdf({
      //     id: id,
      //   });
      //   this.loading = false;
      // }
      
      if (apiRes.result) {
        this.mData.dataForm = apiRes.result;
        this.mData.dataForm.signers.forEach(
          (signer) => {
            if (signer.user_id == this.mData.currentUser.id && signer.position_id) {
              this.isShowTutorialSignDigital = signer.is_digital_signature;
              this.isDigitalSignature = signer.is_digital_signature;
            }
          }
        );
        this.fn_eventBus(
          this.checkTab(this.$route.query.type),
          "sign",
          this.mData.dataForm.name
        );
        this.fn_checkToDisplaySignatureSidebar();
        this.fn_checkShowBtnDocSignTemp(this.mData.dataForm);
        if (
          this.$route.query.type == "DOC_SIGN_CONSENT"
          //  &&
          // pdfPreview.result &&
          // pdfPreview.result.fileBase64 != ""
        ) {
          // this.fileBase64 = 'data:application/pdf;base64, ' + pdfPreview.result.fileBase64;
          // this.fileBase64 = ExtensionService.urlImg + pdfPreview.result.fileId;

          await this.fn_getMainFile();
          this.fn_checkToSetFileId();

          const o = this.mData.dataForm.signers.find(
            (signer) =>
              signer.user_id == this.mData.currentUser.id && signer.position_id
          );
          this.dataObject.position =
            o && o.position ? o.position : this.dataObject.position;
          // console.log(
          //   "111222",
          //   JSON.parse(JSON.stringify(this.dataObject.position))
          // );
          if (o && o.position) {
            this.applySignerPreviewPosition(o.position);
            this.imgSignId = o && o.sign_image_id ? o.sign_image_id : undefined;

            setTimeout(async () => {
              if (o.position.page_index)
                this.fn_checkRedirectToPage(o.position.page_index);
              // this.showChangeSignImage();
              // this.scrollToTop();
            }, 1000);
          }
        } else {
          if (
            this.mData.dataForm.signed_doc_file_id ||
            this.mData.dataForm.doc_file.doc_id
          ) {
            this.fileId = this.mData.dataForm.signed_doc_file_id
              ? this.mData.dataForm.signed_doc_file_id
              : this.mData.dataForm.doc_file.doc_id;
          }
        }
      }
    },

    fn_checkToDisplaySignatureSidebar() {
      if (
        !this.mData.dataForm.signers ||
        (this.mData.dataForm.signers && this.mData.dataForm.signers.length < 0)
      )
        return;
      this.isDuplicatedSigner = false;
      const o = this.mData.dataForm.signers.find(
        (signer) =>
          signer.user_id == this.mData.currentUser.id &&
          signer.status == "WAITING"
      );
      if (o && o.is_add_auto) {
        const arrExceptAutoSigner = this.mData.dataForm.signers.filter(
          (signer) => !signer.is_add_auto
        );
        const duplicatedSigner = arrExceptAutoSigner.findIndex(
          (signer) => signer.user_id == o.user_id
        );
        if (duplicatedSigner >= 0) {
          this.drawerVisible = true;
          this.isDuplicatedSigner = true;
        }
      } else if (o && !o.is_add_auto) {
        this.drawerVisible = true;
        this.isDuplicatedSigner = true;
      } else {
        this.drawerVisible = false;
        this.isDuplicatedSigner = false;
      }
    },

    fn_checkRedirectToPage(pageIndex) {
      this.loading = true;
      this.changePage(pageIndex);
      if (this.pageNum != pageIndex) {
        this.fn_checkRedirectToPage(pageIndex);
      } else {
        this.changePage(pageIndex);
        this.refreshSignatureOverlay();
        this.scrollToTop();
        this.loading = false;
        return;
      }
    },



    fn_getRawSignerPosition(position = {}) {
      return this.fn_getDisplaySignerPosition(position);
    },

    syncPreviewPositionFromHistory() {
      this.dataObject.position = {
        ...(this.dataObject.position || {}),
        x: this.historySign.positionX != null ? this.historySign.positionX : 0,
        y: this.historySign.positionY != null ? this.historySign.positionY : 0,
        width: this.historySign.width != null ? this.historySign.width : 150,
        height: this.historySign.height != null ? this.historySign.height : 150,
        page_index:
          this.historySign.pageSigned ||
          (this.dataObject.position && this.dataObject.position.page_index) ||
          this.pageNum,
        delta_x:
          this.historySign.positionX != null ? this.historySign.positionX : 0,
        delta_y:
          this.historySign.positionY != null ? this.historySign.positionY : 0,
      };
    },

    async fn_getMainFile() {
      if (this.mData.dataForm.doc_file && this.mData.dataForm.doc_file.doc_id) {
        const listFile = await FileApi.list(
          {
            filters: `id=${this.mData.dataForm.doc_file.doc_id}`,
          },
          true
        );
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map((item) => {
            item.url = ExtensionService.getPdfPreviewUrl(item.id);
          });
        }
        this.mData.fileUploadOption.fileMain.fileList = data;
      }
    },

    fn_checkToSetFileId() {
      let fileDetail = {};
      if (this.mData.dataForm.signed_doc_file_id) {
        this.url = ExtensionService.getPdfPreviewUrl(this.mData.dataForm.signed_doc_file_id);
        this.fileId = this.mData.dataForm.signed_doc_file_id;
      } else if (
        this.mData.dataForm.doc_file &&
        this.mData.dataForm.doc_file.doc_id
      ) {
        fileDetail = this.mData.fileUploadOption.fileMain.fileList[0];
        this.url = ExtensionService.getPdfPreviewUrl(fileDetail.id);
        this.fileId = fileDetail.id;
      }
    },

    logSignApproval(stage, payload = {}, level = "log") {
      const logger = console[level] || console.log;
      logger("[DOC_SIGN_APPROVAL][" + stage + "]", {
        routeType: this.$route.query.type,
        documentId: this.mData && this.mData.dataForm ? this.mData.dataForm.id : null,
        fileId: this.fileId,
        currentUserId: this.mData && this.mData.currentUser ? this.mData.currentUser.id : null,
        ...payload,
      });
    },

    getApiBaseUrl() {
      return ((window.MyConfig && window.MyConfig.hostApi) || "").replace(/\/+$/, "");
    },

    buildApiUrl(path) {
      const normalizedPath = path.startsWith("/") ? path : `/${path}`;
      return `${this.getApiBaseUrl()}${normalizedPath}`;
    },

    getSignForApprovalTrace(data) {
      const payload = {
        id: data.id,
        docDigitalSignatureId: this.fileId,
      };
      if (this.isGiapLai && this.numPages > 1 && this.isAllowedGiapLai) {
        payload.giap_lai = {
          Enabled: true,
          StampImageId: this.companySealImageId || undefined,
          StampDiameterPt: 110,
          Opacity: 1.0,
        };
      }
      return {
        method: "POST",
        url: this.buildApiUrl("/documents/SignForApproval"),
        payload,
      };
    },

    getDocumentStatusTrace(documentId) {
      return {
        method: "GET",
        url: this.buildApiUrl(`/documents/${documentId}`),
        payload: {
          id: documentId,
        },
      };
    },

    async fn_submitForm() {
      this.logSignApproval("SUBMIT_START", {
        isDigitalSignature: this.isDigitalSignature,
        activeProcess: this.activeProcess,
      });
      if (this.isDigitalSignature) {
        const notifyError = (mess, stage = "UNKNOWN_STAGE", extra = {}) => {
          this.logSignApproval(stage, { message: mess, ...extra }, "error");
          this.$notify.error({
            message: mess,
            duration: 3000,
            customClass: "doc-error",
          });
        };

        const pluginRes = await SignatureDigitalService.initPlugin();
        if (pluginRes.error) {
          notifyError(pluginRes.mess, "PLUGIN_INIT_FAILED", {
            pluginResponse: pluginRes,
          });
          return;
        }
        this.logSignApproval("PLUGIN_INIT_OK");
        const session = pluginRes.session;

        const resCert = await SignatureDigitalService.getCert(session);

        if (resCert.error) {
          notifyError(resCert.mess, "GET_CERT_FAILED", {
            certResponse: resCert,
          });
          return;
        }
        this.logSignApproval("GET_CERT_OK");
        const cert = resCert.cert;
        this.syncPreviewPositionFromHistory();
        const pageIndex =
          this.dataObject.position && this.dataObject.position.page_index
            ? this.dataObject.position.page_index
            : this.pageNum;
        // Canvas được render ở scale 1.4 (ViewPdf), pdfHeight ở scale 1 (PDF points)
        // Phải chia cho 1.4 thay vì dùng pxToPt (72/96) vốn chỉ đúng với CSS pixel thông thường
        const RENDER_SCALE = 1.4;
        const offsetX = (this.dataObject.position.x || 0) / RENDER_SCALE;
        const offsetYFromTop = (this.dataObject.position.y || 0) / RENDER_SCALE;
        const sigWidth = (this.dataObject.position.width || 150) / RENDER_SCALE;
        const sigHeight = (this.dataObject.position.height || 150) / RENDER_SCALE;
        // PDF dùng tọa độ từ góc dưới-trái, clamp để không ra ngoài trang
        const offsetY = Math.max(0, this.pdfHeight - offsetYFromTop - sigHeight);
    
        // gửi cert + mã hash
        let hashDocumentToSignData ={
            File_id: this.fileId,
            Sign_image_id: this.imgSignId,
            CertChainBase64: cert,
            Position:{
              X: offsetX,
              Y: offsetY,
              Width: sigWidth,
              Height: sigHeight,
              Page_Index: pageIndex,
            }
          };
        this.logSignApproval("HASH_DOCUMENT_REQUEST", {
          hashDocumentToSignData,
        });
        const resSign = await DocumentApi.HashDocumentToSign(hashDocumentToSignData);
        this.logSignApproval("HASH_DOCUMENT_RESPONSE", {
          responseCode: resSign.code,
          hasResult: !!resSign.result,
        });
        const { HashBase64, FileName } = resSign.result;
        // sign
        const hashSign = await SignatureDigitalService.signHash(
          SignatureDigitalService.base64ToHex(HashBase64).toUpperCase(),0,session
        );
        if(hashSign.error) {
          notifyError(hashSign.mess, "SIGN_HASH_FAILED", {
            hashSign,
          });
          return;
        }
        this.logSignApproval("SIGN_HASH_OK");
        const body = {
            Signature: hashSign,
            FileName: FileName,
            FileImage: resSign.result.FileImage,
      };
      this.logSignApproval("INSERT_SIGNATURE_REQUEST", {
        fileName: FileName,
      });
      const res = await DocumentApi.InsertSignatrue(body);
      this.logSignApproval("INSERT_SIGNATURE_RESPONSE", {
        responseCode: res.code,
        hasResult: !!res.result,
      });
        // const offsetX = this.pxToPt(this.dataObject.position.x ?? 0);
        // const offsetY = this.pxToPt( this.dataObject.position.y  ?? 0);
        if(res.result) {
          this.fileId = res.result.FileId;
          this.url = ExtensionService.getDocumentPreviewUrl(this.fileId);
          this.logSignApproval("INSERT_SIGNATURE_OK", {
            signedFileId: this.fileId,
          });
        } else {
          notifyError("Ký duyệt thất bại!", "INSERT_SIGNATURE_EMPTY_RESULT", {
            response: res,
          });
          return;
        }
      }
      try {
        let data = this.mData.dataForm;
        if (this.isGiapLai && !this.companySealImageId) {
          await this.getCompanySeal();
        }
        this.activeProcess = 1;
        this.logSignApproval("SUBMIT_TRY_START", {
          signerCount: data && data.signers ? data.signers.length : 0,
        });

        if (
          this.$route.query.type == "DOC_SIGN_CONSENT" ||
          (this.$route.query.type == "FILTER" &&
            this.$route.query.statusFilter !== "DOC_DRAFF_WAITING")
        ) {
          this.syncPreviewPositionFromHistory();
          data.signers.forEach((signer) => {
            if (
              !signer.is_add_auto &&
              signer.user_id == this.mData.currentUser.id
            ) {
              if (this.imgSignId) {
                signer.sign_image_id = this.imgSignId;
              }
              const previewPosition = this.dataObject.position || signer.position || {};
              const rawPosition = this.fn_getRawSignerPosition(previewPosition);
              const dx = rawPosition.x != null ? rawPosition.x : 0;
              const dy = rawPosition.y != null ? rawPosition.y : 0;
              const w =
                this.historySign.width != null
                  ? this.historySign.width
                  : previewPosition.width || 150;
              const h =
                this.historySign.height != null
                  ? this.historySign.height
                  : previewPosition.height || 150;
              
              const DPI_RATIO = 96 / 72;
              const targetWidth = this.pdfSize.width * DPI_RATIO;
              const targetHeight = this.pdfSize.height * DPI_RATIO;
              const canvasW = this.canvasDimensions.width;
              const canvasH = this.canvasDimensions.height;
              const BE_DELTA = 0.95;

              signer.position = {
                delta_x: dx,
                delta_y: dy,
                x: Math.round(dx * targetWidth / canvasW),
                y: Math.round(dy * targetHeight / canvasH),
                width: Math.round((w * targetWidth / canvasW) / BE_DELTA),
                height: Math.round((h * targetHeight / canvasH) / BE_DELTA),
                page_index:
                  this.historySign.pageSigned ||
                  previewPosition.page_index ||
                  signer.position.page_index,
              };
            }
          });
          const dataUpdate = {
            id: data.id,
            signers: data.signers,
          };
          this.logSignApproval("UPDATE_SIGNER_POSITION_REQUEST", {
            dataUpdate,
          });
          const documentInApiRes1 = await DocumentApi.update(dataUpdate);
          this.logSignApproval("UPDATE_SIGNER_POSITION_RESPONSE", {
            responseCode: documentInApiRes1.code,
            hasResult: !!documentInApiRes1.result,
          });
          if (documentInApiRes1.code == 0 && documentInApiRes1.result) {
            const signForApprovalTrace = this.getSignForApprovalTrace(data);
            this.logSignApproval("SIGN_FOR_APPROVAL_REQUEST", signForApprovalTrace);
            const documentInApiRes = await DocumentApi.SignForApproval(
              signForApprovalTrace.payload
            );
            this.logSignApproval("SIGN_FOR_APPROVAL_RESPONSE", {
              ...signForApprovalTrace,
              responseCode: documentInApiRes.code,
              hasResult: !!documentInApiRes.result,
              response: documentInApiRes,
            });
            if (documentInApiRes.result) {
              // Check status
              await this.fn_checkStatus();
            } else {
              this.logSignApproval("SIGN_FOR_APPROVAL_EMPTY_RESULT", {
                response: documentInApiRes,
              }, "error");
            }
          } else {
            this.logSignApproval("UPDATE_SIGNER_POSITION_FAILED", {
              response: documentInApiRes1,
            }, "error");
          }
        } else if (
          this.$route.query.type == "DOC_SIGN_TEMP" ||
          (this.$route.query.type == "FILTER" &&
            this.$route.query.statusFilter == "DOC_DRAFF_WAITING")
        ) {
          if (
            this.fn_checkStatusOfCurrentTempSigner() &&
            !this.isShowBtnDocSignTemp
          )
            return;
          const objWaitingSigner = data.signers.find(
            (signer) => signer.status == "WAITING"
          );
          this.logSignApproval("SIGN_TEMP_REQUEST", {
            waitingSignerId: objWaitingSigner ? objWaitingSigner.user_id : null,
          });
          const documentInApiRes = await DocumentApi.SignForApprovalDraff({
            id: data.id,
            signer_id: objWaitingSigner.user_id,
          });
          this.logSignApproval("SIGN_TEMP_RESPONSE", {
            responseCode: documentInApiRes.code,
            hasResult: !!documentInApiRes.result,
            response: documentInApiRes,
          });
          if (documentInApiRes.result && !this.isDigitalSignature) {
            this.$notify.success({
              message: "Ký nháy thành công.",
              duration: 3000,
              customClass: "doc-success",
            });
            this.fn_goBack();
          }
        }
      } catch (error) {
        // console.log(error);
        if (error.code == 404 || error.code == 401) {
          this.logSignApproval("SUBMIT_CATCH_AUTH_OR_NOT_FOUND", {
            error,
          }, "error");
          this.loading = false;
          this.$notify.warning({
            message: `${error.detail}.`,
            duration: 3000,
            customClass: "doc-warning",
          });
          return;
        }
        this.logSignApproval("SUBMIT_CATCH_UNKNOWN", {
          error,
        }, "error");
        this.loading = false;
        this.$notify.warning({
          message: "Ký duyệt thất bại!",
          duration: 3000,
          customClass: "doc-warning",
        });
      }
    },
    pxToPt(px) {
      return px * (72 / 96); 
    },

    fn_checkStatusOfCurrentTempSigner() {
      const mainSignerName = this.fn_getPreSignerRequestTempSign(
        this.mData.dataForm
      );
      if (!this.isShowBtnDocSignTemp) {
        this.$notify.info({
          message: `Văn bản đã được ${
            mainSignerName ? mainSignerName : ""
          } ký duyệt, không thể thao tác.`,
          duration: 5000,
          customClass: "doc-info",
        });
        setTimeout(() => {
          this.fn_goToList();
        }, 3000);
      }
      return true;
    },

    fn_getPreSignerRequestTempSign(data) {
      if (!data.signers || (data.signers && data.signers.length < 0)) return;
      let mainSignerName = null;
      const objSigner = data.signers.findLast((signer) =>
        signer.status == "SIGNED" &&
        signer.request_temp_signers &&
        signer.request_temp_signers.length > 0
      );
      if (objSigner) {
        const tempSigner = objSigner.request_temp_signers.find(
          (tempSigner) => tempSigner.user_id == this.mData.currentUser.id
        );
        if (tempSigner) {
          const mainSigner = this.listMainSigner.find(
            (emp) => emp.id == objSigner.user_id
          );

          mainSignerName = mainSigner
            ? mainSigner.administrative_info.name.full_name
            : "";
        }
      }
      return mainSignerName;
    },

    async fn_getListMainSigner(data) {
      const listMainSignerId = data.signers.map(
        (signer) => signer.user_id
      );
      const employeeApiRes = await EmployeeApi.list({
        field: "administrative_info",
        filters: `id:in:${listMainSignerId}`,
      });
      if (employeeApiRes.result) {
        this.listMainSigner = employeeApiRes.result;
      }
    },

    async fn_checkStatus() {
      this.loading = true;
      const documentId = this.$route.params.id;
      const documentStatusTrace = this.getDocumentStatusTrace(documentId);
      this.logSignApproval("CHECK_STATUS_REQUEST", documentStatusTrace);
      const documentApiRes = await DocumentApi.findById(
        documentId,
        true
      );
      if (documentApiRes.result) {
        const currentSigner = documentApiRes.result.signers.find(
          (signer) => signer.user_id == this.mData.currentUser.id
        );
        this.logSignApproval("CHECK_STATUS_RESPONSE", {
          ...documentStatusTrace,
          documentStatus: documentApiRes.result.status,
          currentSignerStatus: currentSigner ? currentSigner.status : null,
          currentSigner,
          response: documentApiRes,
        });
        if (currentSigner && currentSigner.status == "SIGNED") {
          setTimeout(() => {
            this.loading = false;
            this.$notify.success({
              message: "Ký duyệt thành công.",
              duration: 3000,
              customClass: "doc-success",
            });
            this.fn_goBack();
          }, 1000);
        } else if (currentSigner && currentSigner.status == "SIGNED_FAILED") {
          this.logSignApproval("CHECK_STATUS_SIGNED_FAILED", {
            ...documentStatusTrace,
            currentSigner,
            response: documentApiRes,
          }, "error");
          this.loading = false;
          this.$notify.warning({
            message: "Ký duyệt thất bại.",
            duration: 3000,
            customClass: "doc-warning",
          });
          await this.fn_goBack();
        } else {
          this.logSignApproval("CHECK_STATUS_RETRY", {
            currentSignerStatus: currentSigner ? currentSigner.status : null,
          });
          await this.fn_checkStatus();
        }
      }
    },

    fn_checkShowBtnDocSignTemp(data) {
      this.isShowBtnDocSignTemp = false;
      if (data.status == "WAITING_FOR_SIGN") {
        if (
          this.$route.query.type == "DOC_SIGN_TEMP" &&
          data.signers &&
          data.signers.length > 0
        ) {
          const objSigner = data.signers.find(
            (signer) =>
              signer.status == "WAITING" ||
              signer.status == "SIGNING" ||
              signer.status == "SIGNED_FAILED"
          );
          if (
            objSigner &&
            objSigner.request_temp_signers &&
            objSigner.request_temp_signers.length > 0
          ) {
            const objTempSigner = objSigner.request_temp_signers.findIndex(
              (tempSigner) =>
                tempSigner.user_id == this.mData.currentUser.id &&
                (tempSigner.status == "NEW" ||
                  tempSigner.status == "WAITING" ||
                  tempSigner.status == "SIGNED_FAILED")
            );
            if (objTempSigner >= 0) {
              this.isShowBtnDocSignTemp = true;
            }
          }
        }
      }
    },

    fn_toggleDrawer() {
      this.drawerVisible = !this.drawerVisible;
    },

    changePage(pageNum) {
      this.pageNum = pageNum;
    },

    refreshSignatureOverlay() {
      this.signatureRenderKey += 1;
    },

    getDefaultVisibleSignPosition(signWidth = 220, signHeight = 160) {
      const pdfContent = this.$el ? this.$el.querySelector(".pdf-content") : null;
      const canvas = pdfContent ? pdfContent.querySelector("canvas") : null;
      if (!pdfContent || !canvas) {
        return { x: 24, y: 24 };
      }
      const offset = 24;
      const maxX = Math.max(0, canvas.width - signWidth);
      const maxY = Math.max(0, canvas.height - signHeight);
      const visibleLeft = Math.max(0, pdfContent.scrollLeft || 0);
      const visibleTop = Math.max(0, pdfContent.scrollTop || 0);

      const x = Math.min(
        maxX,
        Math.max(0, visibleLeft + offset)
      );
      const y = Math.min(
        maxY,
        Math.max(0, visibleTop + offset)
      );

      return { x, y };
    },

    scrollToTop() {
      document.querySelector(".app-body").scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },

    fn_checkTarget() {
      if (!this.targetSigner) {
        return this.mData.dataForm.signers.find(
          (signer) =>
            signer.user_id == this.currentEmployeeInfo.id && signer.position_id
        );
      }
      const target = this.targetSigner.split("-");
      const empId = target[0];
      const posId = target[1];
      const o = this.mData.dataForm.signers.find(
        (signer) => signer.user_id == empId && signer.position_id == posId
      );
      return o;
    },

    async changeSignImage(imageSignId) {
      let isHadSign = false;
      const currentSigner = this.fn_checkTarget();
      if (
        currentSigner &&
        currentSigner.position &&
        this.historySign.pageSigned &&
        this.historySign.pageSigned != this.pageNum
      ) {
        isHadSign = true;
        this.imgSignId = currentSigner.sign_image_id || this.historySign.imageSignId;
        this.$notify.info({
          message: `Vui lòng xóa chữ ký ở trang cũ để chọn chữ ký mới.`,
          duration: 3000,
          customClass: "doc-info",
        });
        return;
      }
      this.imgSignId = imageSignId;

      const img = new Image();
      img.src = ExtensionService.urlImg + imageSignId;
      await new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve;
        setTimeout(resolve, 300);
      });

      const signWidth =
        img && img.width > 0
          ? Math.max(140, Math.min(img.width * 3, 220))
          : 220;
      const signHeight =
        img && img.height > 0
          ? Math.max(90, Math.min(img.height * 3, 160))
          : 160;

      this.historySign.imageSignId = imageSignId;
      this.historySign.pageSigned = this.pageNum;
      if (!isHadSign) {
        const defaultPosition = this.getDefaultVisibleSignPosition(
          signWidth,
          signHeight
        );
        this.historySign.positionX = defaultPosition.x;
        this.historySign.positionY = defaultPosition.y;
      }
      this.historySign.width = signWidth;
      this.historySign.height = signHeight;

      this.dataObject.position = {
        delta_x: 0,
        delta_y: 0,
        x: this.historySign.positionX != null ? this.historySign.positionX : 0,
        y: this.historySign.positionY != null ? this.historySign.positionY : 0,
        width: this.historySign.width,
        height: this.historySign.height,
        page_index: this.pageNum,
      };
      this.checkHaveHistorySign();
      await this.fn_saveSignPosition();
      this.refreshSignatureOverlay();
    },

    fn_deleteSignImage() {
      this.imgSignId = undefined;
      this.haveHistory = false;
      this.historySign = {
        imageSignId: undefined,
        pageSigned: 0,
        positionX: 0,
        positionY: 0,
        width: 150,
        height: 150,
        page_index: 1,
      };
      this.dataObject.position = {
        page_index: this.pageNum,
        x: 0,
        y: 0,
        width: 150,
        height: 150,
      };

      const currentSigner = this.fn_checkTarget();
      if (currentSigner) {
        currentSigner.sign_image_id = undefined;
        currentSigner.position = undefined;
        currentSigner.is_has_sign = undefined;
      }

      this.refreshSignatureOverlay();
    },

    endDragSign(data) {
      this.historySign.imageSignId = data.imageSignId;
      this.historySign.pageSigned = data.pageSigned;
      this.historySign.positionX = data.positionX;
      this.historySign.positionY = data.positionY;
      this.historySign.width = data.width;
      this.historySign.height = data.height;
      this.syncPreviewPositionFromHistory();
      this.checkHaveHistorySign();
      this.fn_saveSignPosition();
    },

    endResizeSign(data) {
      this.historySign.imageSignId = data.imageSignId;
      this.historySign.pageSigned = data.pageSigned;
      this.historySign.positionX = data.positionX;
      this.historySign.positionY = data.positionY;
      this.historySign.width = data.width;
      this.historySign.height = data.height;
      this.syncPreviewPositionFromHistory();
      this.checkHaveHistorySign();
      this.fn_saveSignPosition();
    },

    // Save sign's position of signers
    fn_saveSignPosition() {
      this.syncPreviewPositionFromHistory();
      const signer = this.mData.dataForm.signers.find(
        (signer) =>
          signer.user_id == this.currentEmployeeInfo.id && signer.position_id
      );
      if (!signer) return;

      const empId = signer.user_id;
      const posId = signer.position_id;
      this.mData.dataForm.signers.forEach((signer) => {
        if (
          signer.user_id == empId &&
          signer.position_id &&
          signer.position_id == posId
        ) {
          const DPI_RATIO = 96 / 72;
          const targetWidth = this.pdfSize.width * DPI_RATIO;
          const targetHeight = this.pdfSize.height * DPI_RATIO;
          const canvasW = this.canvasDimensions.width;
          const canvasH = this.canvasDimensions.height;
          const BE_DELTA = 0.95;

          const rawX = this.historySign.positionX != null ? this.historySign.positionX : this.dataObject.position.x;
          const rawY = this.historySign.positionY != null ? this.historySign.positionY : this.dataObject.position.y;
          const rawW = this.historySign.width != null ? this.historySign.width : this.dataObject.position.width;
          const rawH = this.historySign.height != null ? this.historySign.height : this.dataObject.position.height;

          signer.position = {
            delta_x: rawX != null ? rawX : 0,
            delta_y: rawY != null ? rawY : 0,
            x: Math.round(rawX * targetWidth / canvasW),
            y: Math.round(rawY * targetHeight / canvasH),
            width: Math.round((rawW * targetWidth / canvasW) / BE_DELTA),
            height: Math.round((rawH * targetHeight / canvasH) / BE_DELTA),
            page_index:
              this.historySign.pageSigned ||
              (this.dataObject.position && this.dataObject.position.page_index) ||
              this.pageNum,
          };
        }
        return signer;
      });
    },

    async getEmployeeSign(data, signer_id) {
      data = { user_id: signer_id ? signer_id : this.mData.currentUser.id };
      this.fileUploadOption.FileChuKy.listImageSigns = [];
      const employeeSignatureApiRes = await EmployeeSignatureApi.list({
        filters: `employee_id=${data.user_id}`,
      });
      if (
        employeeSignatureApiRes.result &&
        employeeSignatureApiRes.result.length > 0
      ) {
        if (!employeeSignatureApiRes.result[0].image_ids) {
          employeeSignatureApiRes.result[0].image_ids = [];
        }
        this.listEmployeeSignatures = employeeSignatureApiRes.result[0];
      } else {
        this.listEmployeeSignatures = {
          employee_id: data.user_id,
          image_ids: [],
        };
      }
      (this.listEmployeeSignatures.image_ids || []).forEach((item) => {
        this.fileUploadOption.FileChuKy.listImageSigns.push({
          sign_image_id: item,
          url: ExtensionService.urlImg + item,
        });
      });
    },

    async getCompanySeal() {
      try {
        const companyInfo = MethodService.getCompanyInfo();
        const filter = companyInfo && companyInfo.id ? { company_id: companyInfo.id } : { limit: 10 };
        const res = await CompanySignApi.list(filter, true);
        if (res && res.result && res.result.length > 0) {
          const sealRecord = res.result[0];
          if (Array.isArray(sealRecord.image_ids) && sealRecord.image_ids.length > 0) {
            this.companySealImageId = sealRecord.image_ids[0];
            return this.companySealImageId;
          }
        }
      } catch (err) {
        console.error("Lỗi lấy con dấu tổ chức:", err);
      }
      return null;
    },

    changePageNum(data) {
      this.pageNum = data.pageNum;
      this.numPages = data.numPages;
      this.scrollToTop();

      const currentSigner = this.fn_checkTarget();
      if (
        currentSigner &&
        currentSigner.position &&
        this.historySign.pageSigned &&
        this.historySign.pageSigned == this.pageNum
      ) {
        this.applySignerPreviewPosition(currentSigner.position);
        this.refreshSignatureOverlay();
      }
    },

    checkHaveHistorySign() {
      this.haveHistory = false;
      if (this.historySign.imageSignId) {
        this.haveHistory = true;
      } else {
        this.haveHistory = false;
      }
    },

    async fn_initData() {
      this.dataObject.position = {
        page_index: this.historySign.pageSigned,
        x: this.historySign.positionX,
        y: this.historySign.positionY,
        width: this.historySign.width,
        height: this.historySign.height,
      };
      this.fn_eventBus(this.checkTab(this.$route.query.type), "sign");
      await this.getEmployeeSign();
      await this.getCompanySeal();
      await this.fn_getDataById(this.$route.params.id);
      if (this.$route.query.type == "DOC_SIGN_TEMP") {
        await this.fn_getListMainSigner(this.mData.dataForm);
        await this.fn_checkStatusOfCurrentTempSigner();
      }
    },

    handleCanvasDimensions(dimensions) {
      const isChanged =
        dimensions.width !== this.canvasDimensions.width ||
        dimensions.height !== this.canvasDimensions.height;
      this.canvasDimensions = dimensions;
      if (!isChanged) return;

      const currentSigner = this.fn_checkTarget();
      if (
        currentSigner &&
        currentSigner.position &&
        currentSigner.position.page_index === this.pageNum
      ) {
        this.applySignerPreviewPosition(currentSigner.position);
        this.refreshSignatureOverlay();
      }
    },

    handlePdfSize(size) {
      if (size) {
        this.pdfSize = size;
        this.pdfHeight = size.height || 0;
      }
    },

    toggleGiapLai() {
      this.isGiapLai = !this.isGiapLai;
      if (this.isGiapLai) {
        this.$nextTick(() => {
          const dropzone =
            document.getElementById("pdf-content") ||
            document.querySelector(".dropzone");
          if (dropzone) {
            dropzone.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
      }
    },
  },

  async created() {
    await this.fn_initData();
  },
};
</script>

<style lang="scss" scoped>
.preview-iframe {
  height: calc(100vh - 165px);
}
::v-deep .body-pdf {
  position: relative;
}
::v-deep #pdf-content {
  margin-left: 0;
}
.drawer-container {
  .drawer {
    position: absolute;
    top: 0;
    right: 0;
    background: #d0d5d9;
    width: 25%;
    height: 100%;
    overflow: hidden;
    box-shadow: -3px 0px 2px 0px rgb(0 0 0 / 7%);
    z-index: 250;
  }
  .drawer-collapse {
    position: absolute;
    top: 0;
    right: 0;
    background: #292d32;
    width: 3%;
    height: 100%;
    overflow: auto;
    z-index: 250;
    .drawer__header {
      flex-direction: column;
      background: #292d32;
      .drawer__header-title {
        background: #292d32;
        writing-mode: vertical-rl;
      }
    }
  }
  .drawer__header {
    background: #444242;
    padding: 15px 10px;
    .drawer__header-title {
      color: var(--white);
    }
  }
  .drawer__box {
    height: 100%;
    .drawer__box-title {
      padding: 10px 10px;
      background: #ababab;
      color: #292d32;
    }
    .drawer__box-content {
      padding: 10px;
      max-height: calc(100% - 90px);
      overflow: auto;
    }
  }
}

::v-deep .list-sign-image {
  width: 100%;
  padding: 0 10px;
  // max-height: calc(100vh - 200px);
  overflow-y: auto;
  .radio-group {
    display: flex;
    flex-direction: column;
    .el-radio {
      position: relative;
      .el-radio__input {
        position: absolute;
        top: -3px;
        left: -15px;
        background-color: transparent;
        padding: 7px;
        border-radius: 50%;
        &.is-checked + .el-radio__label {
          color: #5e9bbc;
        }
        &.is-checked {
          .el-radio__inner {
            border-color: #5e9bbc;
            background: #fff;
          }
        }
        .el-radio__inner {
          width: 24px;
          height: 24px;
          border-color: #5e9bbc;
          &:hover {
            border-color: #5e9bbc;
          }
          &::after {
            width: 16px;
            height: 16px;
            background-color: #5e9bbc;
            border-color: #5e9bbc;
          }
        }
      }
    }
    .border-image {
      border: 1.5px solid #5e9bbc;
      border-radius: 2px;
      padding: 10px;
      text-align: center;
      // position: relative;
      .el-image {
        max-width: 300px;
      }
      .el-upload-dragger {
        max-width: 200px;
        height: 200px;
        border-radius: 50%;
        border-width: 2px;
        .el-upload__text {
          line-height: 20px;
        }
      }
    }
  }
}
::v-deep .border-image {
  border: 1.5px solid #5e9bbc;
  border-radius: 2px;
  padding: 10px;
  text-align: center;
  .el-image {
    max-width: 300px;
  }
  .el-upload-dragger {
    max-width: 200px;
    height: 200px;
    border-radius: 50%;
    border-width: 2px;
    .el-upload__text {
      line-height: 20px;
    }
  }
  .el-upload-list {
    display: none;
  }
}
::v-deep .pdf-content {
  width: 100%;
  position: relative;
  overflow-y: auto;
  overflow-x: auto;
}

::v-deep .pdf-content .canvas {
  position: relative;
  width: fit-content;
  margin: 0 auto;
}

::v-deep .dropzone {
  margin: 0 auto;
  position: relative;
  p {
    color: var(--white);
  }
  .current-page {
    width: 50px !important;
    .el-input {
      .el-input__inner {
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }
}
.pdf-container {
  position: relative;
  background: #444242;
  padding: 10px 0 5px;
  overflow: hidden;
  z-index: 10;
}
::v-deep .el-steps {
  font-family: "UTM Avo", "san-serif";
  .el-step__head {
    .el-step__icon {
      color: var(--white);
      background-color: #c1c5cc;
    }
    .el-step__line {
      left: 25px;
      right: 10px;
    }
  }
  .el-step__head.is-success,
  .el-step__head.is-process {
    .el-step__icon {
      border-radius: 50%;
      border-color: var(--turquoise);
      background-color: var(--turquoise);
      .el-step__icon-inner {
        color: var(--white);
      }
      .el-icon-check::before {
        content: "1";
        font-family: "UTM Avo", "san-serif";
        font-weight: 700;
        font-size: 13px;
        text-align: center;
        line-height: 1;
        color: var(--white);
      }
    }
  }
  .el-step__main {
    width: max-content;
    padding: 0 10px;
    background-color: #fffaf7;

    position: absolute;
    top: -8px;
    left: 25px;
    .el-step__title.is-success {
      font-weight: bold;
      color: var(--black);
    }
  }
}

::v-deep .theme--light.v-stepper {
  background: transparent;
  &:not(.v-sheet--outlined) {
    box-shadow: none;
  }
  .v-stepper__step {
    .v-stepper__step__step {
      font-weight: bold;
      background-color: var(--turquoise);
      margin-right: 5px;
    }
    .v-stepper__label {
      font-weight: bold;
    }
  }
}
::v-deep .main {
  .container-fluid {
    padding: 20px 20px 10px 25px;
  }
}

.preview__file-container {
  background: #bebebe;
  width: 100%;
  height: 100vh;
  box-shadow: 7px 7px 21px -7px rgb(0, 0, 0, 30%);
}
.checked {
  background: #d0e8f5 !important;
}
::v-deep .el-input__inner {
  border-radius: 0;
  box-shadow: none !important;
  border-radius: 5px !important;
}
::v-deep .el-checkbox {
  .el-checkbox__input.is-checked {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__input.is-focus {
    .el-checkbox__inner {
      border-color: var(--turquoise) !important;
    }
  }
  .el-checkbox__input.is-indeterminate {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border-color: var(--turquoise);
    top: 3px;
    &:hover {
      border-color: var(--turquoise) !important;
    }
    &:focus {
      border-color: var(--turquoise) !important;
    }
    &:active {
      border-color: var(--turquoise) !important;
    }
  }
}
::v-deep .el-textarea__inner {
  border-radius: 0;
  box-shadow: none !important;
  border-radius: 5px !important;
}
::v-deep .el-input__prefix {
  .el-input__icon.fa-search {
    margin-left: 7px;
  }
}

::v-deep .el-textarea__inner {
  height: calc(100vh - 95px);
}

::v-deep .el-tabs__item {
  border-radius: 0;
  background-color: #e9e9e9;

  span {
    color: black;
  }
}

::v-deep .el-tabs__nav:not(.is-active)::after {
  content: "";
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 100%;
  height: 2px;
  background: #d0d5d9;
}

::v-deep .el-tabs--border-card > .el-tabs__header {
  .el-tabs__item {
    font-size: 13px;
    border-top: 2px solid transparent;
    margin: 0;
    position: relative;

    &:not(:last-child)::before {
      content: "";
      position: absolute;
      top: 5px;
      right: -1px;
      width: 1px;
      height: 75%;
      background: #7e7e7e;
    }
  }

  .el-tabs__item.is-active {
    border-top: 2px solid var(--orange) !important;
    border-left: none;

    span {
      color: black;
      font-weight: bold;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -1px;
      right: 0px;
      width: 100%;
      height: 2px;
      background: #fff;
      z-index: 1000;
    }
  }
}
::v-deep .btn-default.dark-green {
  background: var(--dark-green) !important;
  border: 1px solid var(--dark-green) !important;

  &:focus {
    background: var(--dark-green) !important;
  }

  &:hover {
    background: #15c765 !important;
  }

  &:active {
    background: var(--dark-green) !important;
  }
}

::v-deep .btn-default.dark-blue {
  background: var(--dark-blue) !important;
  border: 1px solid var(--dark-blue) !important;

  &:focus {
    background: var(--dark-blue) !important;
  }

  &:hover {
    background: #438eff !important;
  }

  &:active {
    background: var(--dark-blue) !important;
  }
}

::v-deep .icon {
  cursor: pointer;
  font-size: 21px;
}

::v-deep .isax-trash {
  color: var(--red);
}

::v-deep .isax-eye {
  color: var(--orange);
}

::v-deep .el-dialog__body {
  padding: 0px !important;
}

::v-deep .el-dialog__header {
  // background-color: #fff !important;
  border-bottom: 1px solid #fff !important;
}

::v-deep .tutorial-sign-digital{
  width: 90%;
  margin: 0 auto;
}

::v-deep .datePicker .el-input__prefix,
.el-input__suffix {
  right: 5px;
  left: auto;
}

::v-deep .el-input--suffix .el-input__inner {
  padding-left: 15px;
  padding-right: 15px;
}

::v-deep .el-tag {
  border: none;
  border-radius: 8px;
  background-color: #d0e8f5;
  .el-avatar--small {
    width: 23px;
    height: 23px;
    line-height: 28px;
  }
  .el-icon-close {
    color: var(--black);
    top: 0;
    &:hover {
      color: var(--white);
    }
  }
}
::v-deep .el-tag--small {
  height: 36px;
}

::v-deep .el-divider--horizontal {
  margin: 10px 0;
}
.empty-content {
  height: 500px;
  padding: 200px 0;
}
::v-deep .el-input__prefix {
  .el-input__icon.fa-search {
    margin-left: 7px;
  }
}

::v-deep .el-tabs--border-card > .el-tabs__header {
  .el-tabs__item {
    font-size: 13px;
    border-top: 2px solid transparent;
    margin: 0;
    position: relative;

    &:not(:last-child)::before {
      content: "";
      position: absolute;
      top: 5px;
      right: -1px;
      width: 1px;
      height: 75%;
      background: #7e7e7e;
    }
  }

  .el-tabs__item.is-activeProcess {
    border-top: 2px solid var(--orange) !important;
    border-left: none;
    // border-right: none;

    span {
      color: black;
      font-weight: bold;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -1px;
      right: 0px;
      width: 100%;
      height: 2px;
      background: #fff;
      z-index: 1000;
    }
  }
}
.icon-prefix,
.icon-suffix {
  font-size: 21px;
}

.el-icon-d-arrow-left,
.el-icon-d-arrow-right {
  font-size: 16px;
  background: #fff;
  border-radius: 1px;
}

::v-deep .el-tabs__content {
  overflow: auto;
  .el-tab-pane {
    height: calc(100vh - 225px);

    // overflow-y: scroll;
    .center-block {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

::v-deep .el-tabs__item {
  border-radius: 0;
  background-color: #e9e9e9;

  span {
    color: black;
  }
}

::v-deep .el-tabs__nav:not(.is-active)::after {
  content: "";
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 100%;
  height: 2px;
  background: #d0d5d9;
}

::v-deep .el-tabs--border-card > .el-tabs__header {
  .el-tabs__item {
    font-size: 13px;
    border-top: 2px solid transparent;
    margin: 0;
    position: relative;

    &:not(:last-child)::before {
      content: "";
      position: absolute;
      top: 5px;
      right: -1px;
      width: 1px;
      height: 75%;
      background: #7e7e7e;
    }
  }

  .el-tabs__item.is-active {
    border-top: 2px solid var(--orange) !important;
    border-left: none;

    span {
      color: black;
      font-weight: bold;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -1px;
      right: 0px;
      width: 100%;
      height: 2px;
      background: #fff;
      z-index: 1000;
    }
  }
}

.giap-lai-btn {
  height: 36px;
  padding: 0 4px;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  background-color: transparent;
  border: 1px solid #dcdfe6;
  transition: all 0.2s ease;

  .giap-lai-label {
    font-size: 14px;
    color: #4b5563;
    white-space: nowrap;
    margin-bottom: 0;
    font-family: 'LexendDeca Regular', sans-serif;
  }

  &:hover {
    background-color: #fff6f0;
    border-color: #ffeadc;
  }

  &.is-checked {
    background-color: #ffeadc;
    border-color: #ffeadc;

    .giap-lai-label {
      color: #000000;
      font-weight: 500;
    }

    &:hover {
      background-color: #ffe3d1;
    }
  }
}
</style>

<style lang="scss">
.button-prev {
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 5%;
  z-index: 98;
}
.button-next {
  border-radius: 5px;
  position: absolute;
  top: 50%;
  right: 5%;
  z-index: 98;
}
</style>
